import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    GetListCompanyEventRequested,
    ClearGetListCompanyEvent,
} from '../../../actions/EventManagement';
import CompanyEventManagement from '../../../pages/Admin/EventManagement/CompanyEventManagement';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => ({
    companyEventData: state.eventManagement.listCompanyEvents.data && state.eventManagement.listCompanyEvents.data,
    listCompanyEvent: state.eventManagement.listCompanyEvents.data && state.eventManagement.listCompanyEvents.data.results,
    isLoading: state.eventManagement.listCompanyEvents.isFetching,
    eventInfo: state.eventManagement.infoEvent?.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchListCompanyEvent: (action) => dispatch(GetListCompanyEventRequested(action)),
    fetchClearListCompanyEvent: () => dispatch(ClearGetListCompanyEvent()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(CompanyEventManagement);
